<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12 mb-3>
          <v-card>
            <v-stepper v-model="steps">
              <v-stepper-header>
                <v-stepper-step :complete="steps > 1" step="1">Surveys</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="steps > 2" step="2">Questions</v-stepper-step>
                <v-divider></v-divider>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-form ref="formSurvey" @submit.prevent="createSurvey">
                    <v-text-field v-model="title" :counter="190" label="Survey name" v-validate="'required|max:190'" :error-messages="errors.collect('title')" data-vv-name="title"></v-text-field>
                    <label for="type">Type of Survey</label>
                    <v-radio-group v-model="type" row>
                      <v-radio label="Mailing" value="mailing" active></v-radio>
                      <v-radio label="Devices" value="devices"></v-radio>
                      <v-radio label="Labor climate" value="labor"></v-radio>
                    </v-radio-group>
                    <v-btn :to="{ name: 'Surveys' }" flat>Cancel</v-btn>
                    <v-btn color="primary" type="submit" class="ml-0">Continue</v-btn>
                  </v-form>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  data () {
    return {
      steps: 1,
      title: '',
      type: 'mailing'
    };
  },
  computed: {
    ...mapGetters(['loading']),
  },
  methods: {
    ...mapActions('survey', [
      'callSelectedSurvey'
    ]),
    ...mapActions(['setSnackbar', 'setLoading']),
    createSurvey () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.setLoading(true);
          const payload = {
            title: this.title,
            type: this.type
          };
          window.axios.post('surveys', payload).then((response) => {
            let surveyResponse = response.data.data;
            payload.client_id = response.data.data.client_id;
            payload.owner_id = response.data.data.owner_id;
            payload.owner_name = response.data.data.owner_name;
            
            /* Action for selected Survey */
            this.callSelectedSurvey(response.data.data);
            this.setSnackbar({
              show: true,
              color: 'green',
              text: 'Survey created Successfully.'
            });
            /* push router */
            this.$router.push({
              name: 'SurveyShow',
              params: {
                survey_id: surveyResponse.id
              }
            });
            
            this.setLoading(false);
          }).catch((error) => {
            this.setLoading(false);
          });
        } else {
          this.setSnackbar({
            show: true,
            color: 'info',
            text: 'Check the form, please.'
          });
        }
      });
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/client/surveys/Create.vue